import barbarian from './barbarian';
import bard from './bard';
import cleric from './cleric';
import druid from './druid';
import fighter from './fighter';
import monk from './monk';
import paladin from './paladin';
import ranger from './ranger';
import rogue from './rogue';
import sorcerer from './sorcerer';
import wizard from './wizard';

const multiclassArchetypes = {
	Barbarian: barbarian,
	Bard: bard,
	Cleric: cleric,
	Druid: druid,
	Fighter: fighter,
	Monk: monk,
	Paladin: paladin,
	Ranger: ranger,
	Rogue: rogue,
	Sorcerer: sorcerer,
	Wizard: wizard,
};

export default multiclassArchetypes;
